module.exports = __webpack_public_path__ + "static/media/heroImage3.828574e4.png";